import React, { useEffect } from 'react';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import { Section, Container } from 'components/shared';
import { isValidTitle } from 'utils/validateTitle';
import { useLocation } from 'react-router-dom';
import { scrollToSection } from 'utils/scrollTo';

import loadable from '@loadable/component';
const SmallTitleAndText = loadable(() =>
  import('components/components/molecules/SmallTitleAndText'),
);
const TimelineGallery = loadable(() =>
  import('components/components/organisms/TimelineGallery'),
);

const TimelineCarousel = ({ fields }) => {
  const timelineCarousel = getFieldValue(fields, 'timelineCarousel');
  const title = timelineCarousel ? timelineCarousel.title : '';
  const text = timelineCarousel ? timelineCarousel.text : '';
  const events = timelineCarousel ? timelineCarousel.events : [];

  const location = useLocation();
  const hash = location.hash;
  useEffect(() => {
    if (hash && hash.substring(1) === 'timeline') {
      setTimeout(() => {
        scrollToSection(hash.substring(1), 80);
      }, 1500);
    }
  });

  if (!(events && events.length > 0)) {
    return null;
  }

  return (
    <>
      <Section id='timeline'>
        <Container>
          {(isValidTitle(title) || isValidTitle(text)) && (
            <SmallTitleAndText
              title={title}
              text={text}
              textAlignment={'center'}
            />
          )}
          <TimelineGallery events={events} />
        </Container>
      </Section>
    </>
  );
};

export default TimelineCarousel;
